<template>
  <div>
    <GiderIsleComp></GiderIsleComp>
  </div>
</template>
<script>

  import GiderIsleComp from "../../../components/Pack/Muhasebe/gider/GiderIsleComp";

  export default {
    components: {GiderIsleComp},
    data() {
      return {

        Sayfa: {
          ButtonAdi: 'Kaydet',
          Adi: 'Gider İşle',
          DuzenleAdi: this.$t('eGenel.10'),
          SilAdi: this.$t('eGenel.11'),
          Arama: this.$t('eGenel.9'),
          Menu: [
            {Adi: 'Excel Yükle', Link: '/muhasebe/gider/excel'},
            {Adi: 'Abonelik İşle', Link: '/muhasebe/gider/abonelik'},
          ],
          MenuDisplay: true,
        },
      }
    },
    methods: {},
    created() {

    },
    computed: {},
    watch: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Muhasebe/gider/gider.vue